import {Box} from '@chakra-ui/react';
import {MapMarkerType} from 'components/shared/add-address-modal/components/map/MapUI';
import dynamic from 'next/dynamic';
import React from 'react';

const DynamicMap = dynamic(() => import('components/shared/add-address-modal/components/map/MapUI'), {ssr: false});
type LatLng = {
  lat: number;
  lng: number;
};
interface OrderCourierMapProps {
  restaurantCoords: LatLng;
  courierCoords: LatLng;
  clientCoords: LatLng;
  restaurantName?: string;
  courierName?: string;
}

const OrderCourierMap: React.FC<OrderCourierMapProps> = ({
  restaurantCoords,
  courierCoords,
  clientCoords,
  restaurantName,
  courierName,
}) => {
  const markers: MapMarkerType = [
    {
      showName: true,
      name: restaurantName ?? '',
      icon: '/map/providerMarker.svg',
      coords: restaurantCoords,
      iconSize: 40,
    },
    {showName: false, name: 'marker2', icon: '/map/homeMarker.svg', coords: clientCoords, iconSize: 40},
    {showName: true, name: courierName ?? '', icon: '/map/courierMarker.svg', coords: courierCoords, iconSize: 40},
  ];
  return (
    <Box width="100%" height="100%">
      <DynamicMap
        defaultCoords={clientCoords}
        markers={markers}
        handleNewCoords={(coord: LatLng) => {
          console.log('New coordinates:', coord);
        }}
        zoom={10}
      />
    </Box>
  );
};

export default OrderCourierMap;
